import { ISelected } from './type';
import { TReduxActions } from '../../types/redux';
import { ESelectedActionTypes } from '../../actions/selected';
import { getKey } from '../../../shared/utils/selected';

export const selectedReducer = (state: ISelected = {}, action: TReduxActions) => {
  let key;

  switch (action.type) {
    case ESelectedActionTypes.Select:
      key = getKey(action.payload.entityId, action.payload.entityType);

      return Object.assign({}, state, {
        [key]: { ...action.payload },
      });

    case ESelectedActionTypes.Unselect:
      key = getKey(action.payload.entityId, action.payload.entityType);
      const newState = Object.assign({}, state);
      delete newState[key];

      return newState;

    case ESelectedActionTypes.UnselectAll:
      return {};

    case ESelectedActionTypes.SelectAll:
      return Object.assign({}, action.payload.ids);

    default:
      return state;
  }
};
